import PropTypes from 'prop-types';

const CardContent = ({children}) => children || null;

CardContent.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.element),
    ]),
};

export default CardContent;
